import { Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import type { InvoiceGroup } from '../../../../../../api/useFreight/types'
import { InvoicePdfButton } from './InvoicePdfButton'
import { ExcelExportButton } from './ExcelExportButton'

export function InvoiceDocumentsSection({
  invoiceGroup,
}: {
  invoiceGroup: InvoiceGroup
}) {
  return (
    <Vertical border='bottom' className='pb-3' style={{ overflow: 'visible' }} gap={8}>
      <Texto appearance='light'>Documents</Texto>

      <Horizontal gap={8} className='pb-2'>
        <Vertical gap={8} style={{ flex: 1 }}>
          <InvoicePdfButton invoiceGroup={invoiceGroup} />
        </Vertical>
        <Vertical gap={8} style={{ flex: 1 }}>
          <ExcelExportButton invoiceGroup={invoiceGroup} />
        </Vertical>
      </Horizontal>
    </Vertical>
  )
}
